
<template>
  <div>
    <div v-if="isAdd" class="flavor-item justify-center" @click="onAddFlavorClick">
      <span class="third-color">+</span>
    </div>

    <div v-else class="flavor-item" :class="selected? 'active': ''" @click="onFlavorClick">
      <van-image :src="flavor.flavorPicture" fit="contain" class="flavor-icon"/>
      <div class="flavor-name-tag">
        <div class="flavor-name text-left">{{flavor.flavorName}}</div>
        <div class="flavor-tag-content">
          <span  v-for="(tag,index) in flavor.labelList" :key="index"  class="flavor-tag">{{tag.labelName}}</span>
        </div>
      </div>

      <div class="select-icon mr-3">
        <img @click="e => onEditFlavorClick(e,flavor)" src="@/assets/icons/v2/icon_edit_flavor.png"/>
      </div>
      <div class="select-icon" v-if="showSelect">
        <img v-if="selected"   src="@/assets/icons/v2/icon_select_flavor.png"/>
        <div v-else class="normal-icon"></div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "FlavorItem",
  props: {
    flavor : {
      type:Object,
      default:()=> {
        return {
        }
      }
    },
    selected: {
      type:Boolean,
      default:false
    },
    showSelect: {
      type:Boolean,
      default:true
    },
    isAdd: {
      type:Boolean,
      default:false
    }
  },
  methods: {
    onAddFlavorClick() {
      this.$emit('onAddFlavor')
    },
    onFlavorClick() {
      this.$emit('onSelectFlavor')
    },
    onEditFlavorClick(e,flavor) {
      this.$emit('onEditFlavor',flavor)
    }
  }
};
</script>


<style scoped lang="less">

.flavor-item {
  border: 1px solid #F1F2F2;
  border-radius: 12px;
  padding:10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  .flavor-icon {
    width: 60px;
    height: 60px;
    min-width:60px;
    min-height:60px;
    border-radius: 10px;
  }

  .flavor-name-tag {
    margin-left:10px;
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow-x: scroll;
    .flavor-name {
      font-size:15px;
    }
    .flavor-tag-content {
      margin-top:10px;
      display: flex;
      flex: 1;
      font-size: 10px;
      flex-direction: row;
      align-items: center;
      overflow-x: scroll;
      .flavor-tag {
        border-radius: 8px;
        background: var(--modeActiveBackground) !important;
        color: var(--modeActiveTextColor) !important;
        padding: 4px 8px;
        margin-right:4px;
      }
    }
  }


  .select-icon {
    width:24px;
    min-width:24px;

    img {
      width:100%;
      height:100%;
    }
  }
  .normal-icon {
    width:24px;
    height:24px;
    border-radius: 50%;
    border: 1px solid #DDD;
  }
}


.active {
  border-radius: 12px;
  border: 1px solid #679AFF;
}


</style>